export default {
    baseApiUrl: process.env.REACT_APP_BASE_API_URL || 'https://dev-api.idxsolution.com/dev-api/api',
}

export const SUB_PATH = process.env.REACT_APP_SUB_PATH === 'localhost' ? '': ''
export const lineRedirectUri = process.env.LINE_REDIRECT_URI || 'https://dev.idxsolution.com/my-account'
export const lineClientId = process.env.LINE_CLIENT_ID || 'xskoKwpb48F3dCjyzkxXbh'

